import { frontendURL } from '../../../helper/URLHelper';
import ChauffeursIndex from './ChauffeursIndex.vue';
import ClientsIndex from './ClientsIndex.vue';
import PartnersIndex from './PartnersIndex.vue';
import ZonesIndex from './ZonesIndex.vue';
import AgendaIndex from './AgendaIndex.vue';
import N8nAutomationIndex from './N8nAutomationIndex.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/taxis/chauffeurs'),
    name: 'taxis_chauffeurs_index',
    component: ChauffeursIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/taxis/clients'),
    name: 'taxis_clients_index',
    component: ClientsIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/taxis/partenaires'),
    name: 'taxis_partners_index',
    component: PartnersIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/taxis/agenda'),
    name: 'taxis_agenda_index',
    component: AgendaIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/taxis/automation'),
    name: 'taxis_automation_index',
    component: N8nAutomationIndex,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/taxis/historique'),
    redirect: to => ({
      name: 'taxis_agenda_index',
      params: to.params,
      query: to.query,
    }),
  },
  {
    path: frontendURL('accounts/:accountId/taxis/zones'),
    name: 'taxis_zones_index',
    component: ZonesIndex,
    meta,
  },
];
